import React, { useEffect, useContext } from 'react';
import { Routes, Route } from 'react-router-dom';

import { ProtectedLayout } from './screens/ProtectedLayout';
import Dashboard from './screens/dashboard/Dashboard';

import NotificationHistory from './screens/behind/NotificationHistory';
import KnockSales from './screens/knock/KnockSales';
import { Login } from './login/Login';
import { LoginLayout } from './login/LoginLayout';
import { ChangePassword } from './login/ChangePassword';
import KnockStoreSettle from './screens/knock/KnockStoreSettle';
import KnockHotelSettle from './screens/knock/KnockHotelSettle';
import KnockStoreOrderSettle from './screens/knock/KnockStoreOrderSettle';
import HotelDevice from './screens/knock/hotelDevice/hotelDevice/HotelDevice';
import HotelDeviceTouch from './screens/knock/HotelDeviceTouch';
import PosTestOrder from './screens/knock/PosTestOrder';
import StoreStatus from './screens/knock/StoreStatus';
import StoreMapping from './screens/knock/StoreMapping/StoreMapping';
import NoticeIndex from './screens/knock/notice/NoticeIndex';
import NoticeEdit from './screens/knock/notice/NoticeEdit';
import HotelDeliveryArea from './screens/knock/HotelDeliveryArea';
import CSChatList from './screens/knock/csChat/csChatList';
import RecommendIndex from './screens/knock/recommend/RecommendIndex';
import RecommendEdit from './screens/knock/recommend/RecommendEdit';
import StoreMenuCopy from './screens/knock/StoreMenuCopy';
import PartnerMapping from './screens/knock/partner/PartnerMapping';
import PartnerStoreStatus from './screens/knock/partner/PartnerStoreStatus';
import CompanyStoreReport from './screens/knock/companyData/storeReport';
import WeatherNoticeEdit from './screens/knock/notice/WeatherNoticeEdit';
import MasterNavigator from './screens/masterNavigator/MasterNavigator';
import DeleteStore from './screens/knock/DeleteStore';

const App = () => {
  React.useEffect(() => {
    if (document) {
      let oDoc: any = document;
      if (process.env.REACT_APP_ENV != undefined && process.env.REACT_APP_ENV === 'PRD') {
        oDoc
          .querySelector('link[rel="manifest"]')
          .setAttribute('href', process.env.PUBLIC_URL + '/manifest.json');
      } else {
        oDoc
          .querySelector('link[rel="manifest"]')
          .setAttribute('href', process.env.PUBLIC_URL + '/manifest_dev.json');
      }
    }
  }, []);

  return (
    <Routes>
      <Route element={<LoginLayout />}>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
      </Route>

      <Route element={<ProtectedLayout />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/changePassword" element={<ChangePassword />} />
        <Route path="/behind/sales/talk" element={<NotificationHistory />} />
        {/* knockknock */}
        <Route path="/knock/sales" element={<KnockSales />} />
        <Route path="/knock/settle/store" element={<KnockStoreSettle />} />
        <Route path="/knock/settle/hotel" element={<KnockHotelSettle />} />
        <Route path="/knock/sales/detail" element={<KnockStoreOrderSettle />} />
        <Route path="/knock/hotel/device" element={<HotelDevice />} />
        <Route path="/knock/hotel/touchdevice" element={<HotelDeviceTouch />} />
        <Route path="/knock/deleteStore" element={<DeleteStore />} />
        <Route path="/knock/store/status" element={<StoreStatus />} />
        <Route path="/knock/store/mapping" element={<StoreMapping />} />
        <Route path="/knock/store/copyMenu" element={<StoreMenuCopy />} />
        <Route path="/knock/hotel/address" element={<HotelDeliveryArea />} />
        <Route path="/knock/notice/index" element={<NoticeIndex />} />
        <Route path="/knock/testOrder" element={<PosTestOrder />} />
        <Route path="/knock/notice/edit/:notice_id" element={<NoticeEdit />} />
        <Route path="/knock/support/chat/:store_id?" element={<CSChatList />} />
        <Route
          path="/knock/notice/weather/edit/:simple_notice_id"
          element={<WeatherNoticeEdit />}
        />
        <Route path="/knock/support/chat/:hotel_id?" element={<CSChatList />} />
        <Route path="/knock/recommend/index" element={<RecommendIndex />} />
        <Route path="/knock/recommend/edit/:store_id/:card_id" element={<RecommendEdit />} />
        <Route path="/knock/partners/mapping" element={<PartnerMapping />} />
        <Route path="/knock/partners/store/status" element={<PartnerStoreStatus />} />
        <Route path="/knock/company/store/report" element={<CompanyStoreReport />} />
        <Route path="/knock/navigate/master" element={<MasterNavigator />} />
      </Route>
    </Routes>
  );
};

export default App;
